import OrderDetailPermissionsPage from "layouts/shared/OrderDetailPermissionsPage";

export default OrderDetailPermissionsPage;
